export default __webpack_public_path__ + "static/media/croma1.b719e84e.png";